// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U3DMlvotyJI8L5Zc0CbA{flex-direction:column;padding:0;display:flex}.BoX0K7x6Nk8CIyFxIi6c{margin-bottom:8px;padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `U3DMlvotyJI8L5Zc0CbA`,
	"messageField": `BoX0K7x6Nk8CIyFxIi6c`
};
export default ___CSS_LOADER_EXPORT___;
